import React from 'react';
import { Link } from 'react-router-dom';
import AvailableAccounts from './AvailableAccounts';
import AddSocialPosting from './AddSocialPosting';
function ProcessSocialPosting() {
  
        return (
            <>
            <div className="breadcrumbs-area">
              <h3>Social Posting</h3>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Get Available Accounts</li>
              </ul>
            </div>
            {/* Breadcubs Area End Here */}
            {/* Exam Schedule Area Start Here */}
            <div className="row">
            <AvailableAccounts />
              {/* <AddSocialPosting /> */}

            </div>
            </>
        );
}

export default ProcessSocialPosting;
